// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__0JVC7","loader--svg":"Loader_loader--svg__N3hZg"};